import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";

import { API_URL } from "./helpers.js";

export const Request = Axios.create({
	baseURL: API_URL,
});

const setAuth = (token, type = "Bearer") => {
	Request.defaults.headers.common["Authorization"] = token
		? `${type} ${token}`
		: null;
};

// Axios success resolver
export const requestResolver = ({ data }) => data;

export const useApi = (initialState) => {
	const initialApiState = {
		api: {
			ready: false,
		},
	};

	const Token = useSelector(({ auth }) => auth.token);

	const [state, setState] = useState(() => ({
		...initialApiState,
		...initialState,
	}));

	useEffect(() => {
		setAuth(Token);

		setState((old) => ({
			...old,
			api: {
				...old.api,
				ready: true,
			},
		}));
	}, [Token]);

	return {
		state,
		setState,
		Request,
	};
};
